/**
 * 长按
 */
export const longTouch = {
  inserted: function(el, binding) {
    let timeID = null;
    el.addEventListener("touchstart", () => {
      timeID = setTimeout(() => {
        binding.value(true);
        clearTimeout(timeID);
      }, 800);
    });
    el.addEventListener("touchend", () => {
      clearTimeout(timeID);
    });
  },
};
